import { useState } from "react";
import { createPortal } from "react-dom";
import { X, Download, Link2, Check, Star } from "lucide-react";
import type { EncuestaQrActiva } from "../lib/api";

function qrImgUrl(texto: string, size = 500) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(texto)}&format=png&margin=10`;
}

/**
 * QR en grande para mostrarle al cliente la pantalla y que lo escanee
 * directamente (mesonero/cajero en la mesa o en caja), sin necesitar
 * acceso a la gestión de la encuesta.
 */
export function EncuestaQrGrandeModal({ encuesta, onClose }: { encuesta: EncuestaQrActiva; onClose: () => void }) {
  const [copiado, setCopiado] = useState(false);
  const url = `${window.location.origin}/encuesta-qr/${encuesta.tokenQr}`;
  const imgUrl = qrImgUrl(url);

  function descargar() {
    const a = document.createElement("a");
    a.href = imgUrl + "&download=1";
    a.download = `encuesta-qr-${encuesta.titulo.replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
  }

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-center space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2 text-left">
            <Star className="size-5 text-amber-500 shrink-0" />
            <div>
              <h2 className="font-display font-bold text-ink-800 leading-tight">{encuesta.titulo}</h2>
              {encuesta.sucursalNombre && <p className="text-xs text-ink-500">{encuesta.sucursalNombre}</p>}
            </div>
          </div>
          <button onClick={onClose} className="text-ink-400 hover:text-ink-700 shrink-0"><X className="size-5" /></button>
        </div>

        <img src={imgUrl} alt={`QR de ${encuesta.titulo}`} className="w-72 h-72 mx-auto rounded-xl border border-ink-200 p-2 bg-white" />

        <p className="text-sm text-ink-500">Pedile al cliente que lo escanee con la cámara de su celular.</p>

        <div className="flex gap-2">
          <button onClick={descargar}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium bg-ink-100 text-ink-700 hover:bg-ink-200">
            <Download className="size-4" /> Descargar
          </button>
          <button
            onClick={() => { navigator.clipboard.writeText(url); setCopiado(true); setTimeout(() => setCopiado(false), 2000); }}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium bg-brand-600 text-white hover:bg-brand-700">
            {copiado ? <Check className="size-4" /> : <Link2 className="size-4" />}
            {copiado ? "Copiado" : "Copiar enlace"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
